import { type Action, FilterActionTypes, action } from "easy-peasy";

import { DEFAULT_DATE } from "./defaults";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<DateModel>) =>
  createLogEffect<DateModel>("DATE", property, false);

export type DateModel = {
  value: string;
  valueOnChange: LogEffect<DateModel>;
  set: Action<DateModel, string>;
};

const dateModel: DateModel = {
  value: DEFAULT_DATE,
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    state.value = payload;
  }),
};

export default dateModel;
